var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    id: "svg895",
    viewBox: "-96 -98.908 832 593.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs879"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style877",
    type: "text/css"
  }, ".e{fill:#f79e1b}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect887",
    display: "inline",
    fill: "#ff5f00",
    strokeWidth: 5.494,
    d: "M224.833 42.298h190.416v311.005H224.833z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path889",
    d: "M244.446 197.828a197.448 197.448 0 0175.54-155.475 197.777 197.777 0 100 311.004 197.448 197.448 0 01-75.54-155.53z",
    fill: "#eb001b",
    strokeWidth: 5.494
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path891",
    d: "M621.101 320.394v-6.372h2.747v-1.319h-6.537v1.319h2.582v6.373zm12.691 0v-7.69h-1.978l-2.307 5.493-2.308-5.494h-1.977v7.691h1.428v-5.823l2.143 5h1.483l2.143-5v5.823z",
    className: "e",
    fill: "#f79e1b",
    strokeWidth: 5.494
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path893",
    d: "M640 197.828a197.777 197.777 0 01-320.015 155.474 197.777 197.777 0 000-311.004A197.777 197.777 0 01640 197.773z",
    className: "e",
    fill: "#f79e1b",
    strokeWidth: 5.494
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.a926ed912779093767a0cd8687855a5f.svg";
export { ForwardRef as ReactComponent };